// 索引里的 doi 字段历史遗留问题：存的是完整可解析 URL(https://doi.org/10.xxx/yyy)
// 而不是纯 DOI 标识符(10.xxx/yyy)。展示和复制前统一去掉这层前缀，不改动源数据。
const DOI_URL_PREFIX_PATTERN = /^\s*(https?:\/\/)?(dx\.)?doi\.org\//i;

export function cleanDoi(doi) {
  if (!doi) return "";
  return doi.trim().replace(DOI_URL_PREFIX_PATTERN, "");
}
